<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesNcrTaskNccResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" :inline-actions-disabled="prop_inline !== '1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="gotoGrandParent"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               customLabel="返回上一页面"
                                               @click="$router.push('/sithMes/quality/sithMesNcrProcessTaskList?pathType=list')">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Liang Gangqiang
// Date 2021-07-19 10:47:54

import emCommonListMixin from "@/mixin/em/common/list";

export default {
    name: "sithMesNcrTaskNccListView",
    mixins: [emCommonListMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            processId: ''
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    mounted() {
        if (this.$route.query.hasOwnProperty('processId')) {
            let processId = Number.parseInt(this.$route.query.processId);
            this.$refs.emListFilter.$_emCustomVuexMixin_filterStore.ncrProcessIdFilter = processId;
            this.processId = processId;
            this.$refs.emListFilter.doQuery();
        }
    },
};
</script>